export const BACKEND_API_DOMAIN = process.env.REACT_APP_BACKEND_API_DOMAIN || '';
